export const ru = {
    placeholder: 'example@company-name.ru',
    continue: 'Продолжить',
    domain_support: 'Домен {domain} в данный момент не поддерживается\nУкажите почту, которая привязана к домену вашей компании',
    email_required: 'Необходимо заполнить почту',
    email_invalid: 'Неверный формат почты',
    error_title: 'Произошла ошибка',
    error_message: 'Пожалуйста, попробуйте позже',
};
